import React, { useEffect, useState } from 'react';
import Exit from '../../../common/buttons/exit/ExitButton';
import Modal from '../../../common/modal/Modal';
import './TvGemistModal.scss';
import { TV_GEMIST_MODAL, ONBOARDING_FINALIZE_NEWSLETTER } from '../../../../constants/Copy';
import { useDispatch } from 'react-redux';
import { fetchSubscribeNewsletter, subscribeNewsletter } from '../../../../actions/profileActions';
import BoxedCheckbox from '../../../common/form/BoxedCheckbox';
import Loader from '../../../common/loader/Loader';
import cx from 'classnames';
import Strip from '../../../common/strip/Strip';

const TvGemistModal = ({ show, onClose, title, description }) => {
	const dispatch = useDispatch();
	const [optInStatus, setOptinStatus] = useState(false);
	const [isNewsletterSubscribed, setIsNewsletterSubscribed] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const onCloseModal = () => {
		if (isNewsletterSubscribed) {
			setIsLoading(true);
			dispatch(subscribeNewsletter()).then(() => {
				setIsLoading(false);
				onClose();
			});
		} else {
			onClose();
		}
	};

	useEffect(() => {
		dispatch(fetchSubscribeNewsletter()).then(({ payload }) => setOptinStatus(payload.optInStatus));
	}, [dispatch]);

	return (
		<Modal show={show} skin="modal__medium-transparent">
			<div className="wrapper-close-modal" onClick={onCloseModal}></div>
			<aside
				className={cx('account-page-modal-wrapper', {
					['account-page-modal-wrapper--loading']: isLoading,
				})}
			>
				<div className="account-page-modal">
					{isLoading && <Loader />}
					<Exit onClick={onCloseModal} />
					<h1>{title}</h1>
					<p>{description}</p>
					<ul>
						{TV_GEMIST_MODAL.LIST.map((item, number) => (
							<li key={`tv-gemist-feature-${number}`}>{item}</li>
						))}
					</ul>
					<h2>{TV_GEMIST_MODAL.SUBTITLE}</h2>
					<Strip
						images={[
							{
								src: {
									avif: '/images/tv-gemist/bigbrother.avif',
									jpg: '/images/tv-gemist/bigbrother.jpg',
								},
								alt: 'Big Brother',
							},
							{
								src: {
									avif: '/images/tv-gemist/help.avif',
									jpg: '/images/tv-gemist/help.jpg',
								},
								alt: 'Help, Mijn Man Is Klusser!',
							},
							{
								src: {
									avif: '/images/tv-gemist/verraders.avif',
									jpg: '/images/tv-gemist/verraders.jpg',
								},
								alt: 'De Verraders (start 16 feb)',
							},
						]}
					/>
					{!optInStatus && (
						<div className="tv-gemist-checkbox">
							<BoxedCheckbox
								inputId="nieuwsbriefcheckbox"
								checked={isNewsletterSubscribed}
								onChange={() => setIsNewsletterSubscribed(!isNewsletterSubscribed)}
							>
								{ONBOARDING_FINALIZE_NEWSLETTER}
							</BoxedCheckbox>
						</div>
					)}
				</div>
			</aside>
		</Modal>
	);
};

export default TvGemistModal;
